import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from "./Card";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { faNotesMedical } from "@fortawesome/free-solid-svg-icons";
import Button from "../components/button";
import { useDispatch, useSelector } from "react-redux";
import { EMenuActions } from "../store";
import { useNavigate } from "react-router-dom";
import { CompanyActions } from "../store/company_dtl";
import { TaxActions } from "../store/tax";
import { useEffect } from "react";
import { UserActions } from "../store/user";

export default function Cart() {
  let dispatch = useDispatch();
  let navigate = useNavigate();

  const cartItems = useSelector((state) => state.EMenu.cartItems);
  const showCartModal = useSelector((state) => state.EMenu.showCartModal);
  // const vatRate = useSelector((state) => state.Tax.vatRate);
  const chargeType = useSelector((state) => state.Tax.chargeType);
  const total = Array.isArray(cartItems) ? cartItems.reduce((accumulator, item) => accumulator + Number(item.sellPrice * item.Quantity), 0) : 0;
  const hideTax = useSelector((state) => state.Tax.hideTax);
  // const serviceCharge = useSelector((state) => state.Tax.serviceCharge);
  //  const stateCharge = useSelector((state) => state.Tax.stateCharge);
  const sumOfTax = useSelector((state) => state.Tax.sumOfTax);
  const inclusiveTotal = Array.isArray(cartItems) ? cartItems.reduce((accumulator, item) => accumulator + (Number(item.TotalPrice) - ((item.Price * (sumOfTax)) * item.Quantity)), 0): 0;
  const exclusiveTotal = Number(total + Number(total * sumOfTax));
  const localStorageNotes = JSON.parse(localStorage.getItem("Notes")) || {};
  const handleSummaryPage = () => {
    dispatch(EMenuActions.setShowCartModal(!showCartModal));
    navigate(`summary`);
    dispatch(EMenuActions.setTotalPrice(total));
    dispatch(TaxActions.setInclusiveTotal(inclusiveTotal));
    dispatch(TaxActions.setExclusiveTotal(exclusiveTotal));
    dispatch(CompanyActions.setSL_TB("undefined"));

  };
  const Price = chargeType === "1" ? Number(total) : exclusiveTotal;

  const formatPrice = Price.toLocaleString("en-NG", {
    style: "currency",
    currency: "NGN",
  });;

  const handleClose = () => {
    dispatch(EMenuActions.setShowCartModal(!showCartModal));
    if (cartItems.length === 0) {
      dispatch(EMenuActions.setTotalPrice([]));
      dispatch(EMenuActions.setDeletedPrice(0));
    }
  };

  useEffect(()=>{
    if(Object.keys(localStorageNotes).length !== 0){
      dispatch(UserActions.setNotes(localStorageNotes));
    }
    
  },[]);

  return (
    <section className="bg-dark/50 z-50 fixed min-h-screen top-0 left-0 right-0 bottom-0">
      <div className="relative">
        <div className="md:w-[80%] lg:w-[70%] xl:w-[50%] sm:w-[85%] m-auto bg-white rounded-lg md:my-2 md:pt-2 p-10 max-sm:p-5 max-sm:mt-4">
          <div
            className="absolute max-sm:right-1 max-sm:-top-4 md:right-2 lg:right-20 xl:right-72 -top-3 p-4 cursor-pointer"
            onClick={handleClose}
          >
            <FontAwesomeIcon
              icon={faXmark}
              size="xl"
              className="max-md:hidden text-light p-2 border-light border-2 rounded-lg bg-primaryLight/30"
            />{" "}
            <FontAwesomeIcon
              icon={faXmark}
              size="xl"
              className="md:hidden text-xl text-danger p-2 rounded-lg bg-danger/10 top-0"
            />
          </div>
          <div className="flex flex-col gap-3 overflow-y-scroll h-[60vh] mt-6">
            {cartItems.length === 0 ? (
              <div className="text-center py-28 font-extrabold text-4xl text-primaryLight">
                <FontAwesomeIcon
                  icon={faCircleQuestion}
                  size="2xl"
                  className="mb-3"
                />
                <p>Cart is Empty</p>
              </div>
            ) : (
              Array.isArray(cartItems) && cartItems.map(
                ({
                  ProductId,
                  image,
                  ProductName,
                  Price,
                  Quantity,
                  TotalPrice,
                }) => (
                  <Card
                    key={ProductId}
                    ProductId={ProductId}
                    image={image}
                    ProductName={ProductName}
                    Price={Price}
                    TotalPrice={TotalPrice}
                    Quantity={Quantity}
                  />
                )
              )
            )}
          </div>
          {cartItems.length === 0 ? null : (
            <div className="my-4 h-[25%] max-sm:mb-4 text-end">
              <div className={`${hideTax === "1" && chargeType === "2"? "flex flex-col justify-end": "hidden"}`}>
              <span>Total Tax</span>
              <p className="font-black text-secondary text-xl mb-4">{(total * sumOfTax).toLocaleString('en-NG', {
                style: 'currency',
                currency: 'NGN',
              })}</p>
              </div>

              {/* <div className="w-full flex justify-between">
                <FontAwesomeIcon
                icon={faNotesMedical}
                size="xl"
                className="text-primary hover:text-dark cursor-pointer"
                /> */}
                <span>Total Amount Payable</span>
              {/* </div> */}
              <p className="font-black text-secondary text-xl mb-4">{formatPrice}</p>
              <Button
                type={"bgBtn"}
                textColor={"text-white"}
                bgColor={"bg-secondary"}
                title={"Proceed to Checkout"}
                onClick={handleSummaryPage}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
